import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

export default function TransferDialog(props) {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [inputData, setInputData] = useState({
    transferAmount: 0,
    closingAmount: props.closingCash,
    fromAccount: null,
    toAccount: null,
    remark: "",
    transferDate: null,
  });
  console.log(props.closingCash, "input");

  const handleInput = (e) => {
    // console.log(e.target.value, "e tar");
    setInputData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };
  const [cashList, setCashList] = useState([]);

  const TransferCreate = () => {
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    const res = api
      .post("transfer-report", inputData, config)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Created Transfer Data!",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });

        // props.setAccModalData([...props.accModalData, response.data.data]);
      });
    props.setOpen(false);
  };

  useEffect(() => {
    const getAccLists = async () => {
      try {
        const res = await api.get("accounting-lists");

        // console.log(
        //   res.data.list.filter(
        //     (el) =>
        //       el._id === "646747d959a9bc811d980727" ||
        //       el._id === "6470e28964b1ba9496d24a8c"
        //   ),
        //   "data"
        // );
        setCashList(
          res.data.list.filter(
            (el) =>
              el._id === "646747d959a9bc811d980727" ||
              el._id === "6470e28964b1ba9496d24a8c"
          )
        );
      } catch (err) { }
    };
    getAccLists();
  }, []);
  return (
    <div>
      <Dialog open={props.open} onClose={props.close} fullWidth maxWidth='md'>
        <DialogTitle>
          {" "}
          <div className='modal-header ok'>
            <h4 className='modal-title'>Transfer</h4>
            <button
              type='button'
              className='close'
              data-dismiss='modal'
              aria-label='Close'
              onClick={props.close}
            >
              <span aria-hidden='true'>&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          <form action='' method='post'>
            {/* @csrf */}
            <div class='modal-body'>
              <div class='form-group'>
                <label for='name'>Transfer Amount</label>
                <input
                  type='number'
                  className='form-control border border-info'
                  name='transferAmount'
                  onChange={handleInput}
                />
              </div>
              <div class='form-group'>
                <label for='name'>Cloing Amount</label>
                <input
                  type='number'
                  disabled
                  value={props.closingCash}
                  className='form-control border border-info'
                  name='closingAmount'
                  onChange={handleInput}
                />
              </div>
              <div className='row'>
                <div className='col-6'>
                  <label for='name'>From Account</label>
                  <select
                    className='form-control'
                    name='fromAccount'
                    onChange={handleInput}
                  >
                    <option hidden>Choose Account</option>
                    {cashList.map((item) => (
                      <option value={item._id}>{item.name}</option>
                    ))}
                  </select>
                </div>
                <div className='col-6'>
                  <label for='name'>To Account</label>
                  <select
                    className='form-control'
                    name='toAccount'
                    onChange={handleInput}
                  >
                    <option hidden>Choose Account</option>
                    {cashList.map((item) => (
                      <option value={item._id}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div class='form-group mt-2'>
                <label for='name'>Remark</label>
                <input
                  type='text'
                  className='form-control border border-info'
                  name='remark'
                  onChange={handleInput}
                />
              </div>
              <div class='form-group'>
                <label for='name'>Date</label>
                <input
                  type='date'
                  className='form-control border border-info'
                  name='transferDate'
                  onChange={handleInput}
                />
              </div>
            </div>
            <div class='modal-footer'>
              <Button
                class='btn btn-secondary'
                data-dismiss='modal'
                onClick={props.close}
              >
                Close
              </Button>
              <Button class='btn btn-primary' onClick={TransferCreate}>
                Save
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
// phyo
//maymyat
